export default "__VITE_ASSET__48ee65d1__"